import { 
    gql, 
    useMutation, 
    ApolloError, 
    MutationTuple 
} from "@apollo/client";
import { 
    UpdateMerchantAdminDataAdminMutationMutation, 
    UpdateMerchantAdminDataAdminMutationMutationVariables
} from "../../../../../schemaTypes";

export const updateMerchantAdminDataAdminMutation = gql`
  mutation UpdateMerchantAdminDataAdminMutation(
    $id: String!
    $input: UpdateAdminInput!
    ) {
    updateMerchantAdminDataAdmin(
        id: $id
        input: $input
      ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export const UpdateMerchantAdminDataAdminController: React.FC<{ children: (data: {
  updateMerchantAdminDataAdmin: MutationTuple<
  UpdateMerchantAdminDataAdminMutationMutation, 
  UpdateMerchantAdminDataAdminMutationMutationVariables
  >[0];
  loading: boolean;
  error?: ApolloError;
  data?: UpdateMerchantAdminDataAdminMutationMutation;
  errors?: { path: string; message: string }[] | null;
  message?: string | null;
}) => React.ReactElement | null }> = ({ children }) => {
  const [updateMerchantAdminDataAdmin, { loading, error, data }] = useMutation<
  UpdateMerchantAdminDataAdminMutationMutation, 
  UpdateMerchantAdminDataAdminMutationMutationVariables
  >(updateMerchantAdminDataAdminMutation);

  // Extract errors and message from the mutation result, matching resolver response
  const errorsRaw = data?.updateMerchantAdminDataAdmin?.errors ?? null;
  const errors = Array.isArray(errorsRaw)
    ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
    : errorsRaw;
  const message = data?.updateMerchantAdminDataAdmin?.message ?? null;

  return children({
    updateMerchantAdminDataAdmin,
    loading,
    error,
    data: data ?? undefined,
    errors,
    message
  });
};